import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { memo, useState, useCallback } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import { useFormikContext } from 'formik';
import FormAccordionCohabitatonData from './form';
import { CohabitationDetailForm } from 'cohabitation/view-models/detail-cohabitation';

interface AccordionCohabitatonDataProps {
  disabled?: boolean;
  isEditMode?: boolean;
}

const AccordionCohabitatonDataComponent = ({
  disabled,
  isEditMode,
}: AccordionCohabitatonDataProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<CohabitationDetailForm>();

  const onFieldAccordionCohabitatonDataChange = useCallback(
    (key, value) => {
      formContext.setFieldValue('accordionCohabitation', {
        ...formContext.values.accordionCohabitation,
        [key]: value,
      });
    },
    [formContext.values.accordionCohabitation, formContext.setFieldValue]
  );

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-cohabitation-data-content"
        id="panel-person-edit-cohabitation-data-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Dati convivenza</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <FormAccordionCohabitatonData
          disabled={disabled}
          isEditMode={isEditMode}
          values={formContext.values.accordionCohabitation}
          onChange={onFieldAccordionCohabitatonDataChange}
        />
      </AccordionDetails>
    </Accordion>
  );
};

AccordionCohabitatonDataComponent.displayName = 'Accordion Cohabitation data component';

const AccordionCohabitatonData = memo(AccordionCohabitatonDataComponent);

export default AccordionCohabitatonData;
